/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Attemptdeletefailed2Inputs */

const zh_learn_attemptdeletefailed2 = /** @type {(inputs: Learn_Attemptdeletefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除作答记录失败`)
};

const en_learn_attemptdeletefailed2 = /** @type {(inputs: Learn_Attemptdeletefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to delete attempt`)
};

const es_learn_attemptdeletefailed2 = /** @type {(inputs: Learn_Attemptdeletefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo eliminar el intento`)
};

/**
* | output |
* | --- |
* | "Failed to delete attempt" |
*
* @param {Learn_Attemptdeletefailed2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_attemptdeletefailed2 = /** @type {((inputs?: Learn_Attemptdeletefailed2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Attemptdeletefailed2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_attemptdeletefailed2(inputs)
	if (locale === "en") return en_learn_attemptdeletefailed2(inputs)
	return es_learn_attemptdeletefailed2(inputs)
});
export { learn_attemptdeletefailed2 as "learn_attemptDeleteFailed" }